import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'
import AppLoading from '@/features/loading'
import { TabContext } from '@mui/lab'
import { Tab, Tabs } from '@mui/material'
import { KeysBalance } from '@/entities/cases/ui/keysBalance'
import { ShopItemList } from '@/widgets/shopItemList'
import WebApp from '@twa-dev/sdk'
import { lang } from '@/shared/constants/lang'
import { useEffect } from 'react'
import { useUnit } from 'effector-react'
import { $selectedCurrency, changeShopCurrency, ShopCurrencies } from '@/entities/payments'
import { $shopItems, $userKeys, getShopItemsFx } from '@/entities/cases'
import { $userLanguage, $userToken } from '@/entities/user'
import { goToTransactionHistory } from '@/app/routing/events'
export const ShopSupplies = () => {
  const { classes } = useStyles()

  const value = useUnit($selectedCurrency)
  const userLanguage = useUnit($userLanguage)
  const shopItemList = useUnit($shopItems)
  const userToken = useUnit($userToken)
  const keysBalance = useUnit($userKeys)
  const texts = lang[userLanguage].pages.shop
  const handleChange = (_: React.SyntheticEvent, newVal: ShopCurrencies) => {
    changeShopCurrency(newVal)
  }

  useEffect(() => {
    if (userToken && !shopItemList) {
      getShopItemsFx(userToken!)
    }
  }, [userToken, shopItemList])

  return !shopItemList ? (
    <AppLoading />
  ) : (
    <>
      <div
        style={{ position: 'absolute', right: '16px', top: '44px', cursor: 'pointer' }}
        onClick={() => goToTransactionHistory()}
      >
        <Icon view="paymentHistory" />
      </div>
      <TabContext value={value}>
        <div className={classes.tabsWrapper}>
          <span className={classes.selectCurrency}>{texts.selectCurrency}:</span>
          <Tabs
            value={value}
            onChange={handleChange}
            className={classes.tabList}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              value="stars"
              label="Stars"
              className={classes.tab}
            />
            <Tab
              value="ton"
              label="TON"
              className={classes.tab}
            />
          </Tabs>
        </div>
        {keysBalance ? <KeysBalance balance={keysBalance} /> : null}
        <div className={classes.headingWrapper}>
          <h1>{texts.heading}</h1>
          <h2>{texts.subHeading}</h2>
        </div>

        <ShopItemList items={shopItemList} />
        <span className={classes.messageSupport}>
          {texts.messageSupport(() => WebApp.openTelegramLink('https://t.me/gamed_support_bot'))}
        </span>
      </TabContext>
    </>
  )
}
